(() => {
  if (window.AmaraFaqAccordionReady) return;
  window.AmaraFaqAccordionReady = true;

  document.addEventListener('toggle', (event) => {
    const openedItem = event.target;
    if (!(openedItem instanceof HTMLDetailsElement) || !openedItem.open) return;

    const group = openedItem.closest('.orlisse-faq__items');
    if (!group) return;

    group.querySelectorAll('details[open]').forEach((item) => {
      if (item !== openedItem) item.removeAttribute('open');
    });
  }, true);
})();
